import { render, staticRenderFns } from "./CustomCss.vue?vue&type=template&id=89206b6e&"
import script from "./CustomCss.vue?vue&type=script&lang=js&"
export * from "./CustomCss.vue?vue&type=script&lang=js&"
import style0 from "./CustomCss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports